module.exports = __webpack_public_path__ + "img/w3_circle_reload_black.ad0b0b2d.png";